import {
    IconHome,
    IconTemplate,
    IconLayoutDashboard,
    IconTags,
    IconCategory,
    IconPhoto,
    IconPrinter,
    IconFileTypePdf,
    IconTextSize,
    IconVideo,
    IconSparkles,
    IconWand,
    IconClipboardList,
    IconMenu2,
    IconBriefcase,
    IconStack2,
    IconFileText,
} from '@tabler/icons-react';
import { ModuleGlyph, MY_DOCS_ICON_COLOR } from './moduleColors';

// Header menu icons reuse the hero-card module SVGs (public/module-icons),
// tinted directly in each module's brand colour (see moduleColors.jsx) so the
// nav mirrors the colourful dashboard module cards.
const ModuleIcon = ({ src }) => <ModuleGlyph src={src} />;


const sohozToolsCategories = [
    {
      labelKey: "tools.pdf.title",
      headerBg:  "bg-red-100/80 dark:bg-red-950/30",
      iconBox:   "bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400",
      titleCls:  "text-red-600 dark:text-red-400",
      countCls:  "text-red-500 dark:text-red-500",
      toolIcon:  "bg-red-100/70 dark:bg-red-900/20 text-red-600 dark:text-red-400",
      moreCls:   "text-red-600 dark:text-red-400",
      icon: <IconFileTypePdf size={20} />,
      tools: [
        { labelKey: "tools.pdf.compress",      subtitle: "Compress PDF",      href: "https://sohozkaj.com/tools/pdf/compress" },
        { labelKey: "tools.pdf.merge",         subtitle: "Merge PDFs",        href: "https://sohozkaj.com/tools/pdf/merge" },
        { labelKey: "tools.pdf.create",        subtitle: "Create PDF",        href: "https://sohozkaj.com/tools/pdf/create" },
        { labelKey: "tools.pdf.split",         subtitle: "Split PDF",         href: "https://sohozkaj.com/tools/pdf/split" },
        { labelKey: "tools.pdf.pdfToImage",    subtitle: "PDF to Image",      href: "https://sohozkaj.com/tools/pdf/pdf-to-image" },
        { labelKey: "tools.pdf.lockUnlock",    subtitle: "Lock / Unlock PDF", href: "https://sohozkaj.com/tools/pdf/protect" },
        { labelKey: "tools.pdf.rotate",        subtitle: "Rotate PDF",        href: "https://sohozkaj.com/tools/pdf/rotate" },
        { labelKey: "tools.pdf.removePages",   subtitle: "Remove Pages",      href: "https://sohozkaj.com/tools/pdf/remove-pages" },
        { labelKey: "tools.pdf.watermark",     subtitle: "PDF Watermark",     href: "https://sohozkaj.com/tools/pdf/watermark" },
        { labelKey: "tools.pdf.extractImages", subtitle: "Extract Images",    href: "https://sohozkaj.com/tools/pdf/extract-images" },
        { labelKey: "tools.pdf.permissions",   subtitle: "PDF Permissions",   href: "https://sohozkaj.com/tools/pdf/permissions" },
        { labelKey: "tools.pdf.resize",        subtitle: "Resize PDF",        href: "https://sohozkaj.com/tools/pdf/resize" },
        { labelKey: "tools.pdf.crop",          subtitle: "Crop PDF",          href: "https://sohozkaj.com/tools/pdf/crop" },
        { labelKey: "tools.pdf.pdfToExcel",    subtitle: "PDF to Excel",      href: "https://sohozkaj.com/tools/pdf/pdf-to-excel" },
        { labelKey: "tools.pdf.repair",        subtitle: "Repair PDF",        href: "https://sohozkaj.com/tools/pdf/repair" },
        { labelKey: "tools.pdf.edit",          subtitle: "Edit PDF",          href: "https://sohozkaj.com/tools/pdf/edit" },
      ],
    },

    {
      labelKey: "tools.image.title",
      headerBg:  "bg-amber-100/80 dark:bg-amber-950/30",
      iconBox:   "bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400",
      titleCls:  "text-amber-600 dark:text-amber-400",
      countCls:  "text-amber-500 dark:text-amber-500",
      toolIcon:  "bg-amber-100/70 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400",
      moreCls:   "text-amber-600 dark:text-amber-400",
      icon: <IconPhoto size={20} />,
      tools: [
        { labelKey: "tools.image.compress",          subtitle: "Image Size Reducer",     href: "https://sohozkaj.com/tools/image/compress" },
        { labelKey: "tools.image.nidToPdf",          subtitle: "NID to PDF",             href: "https://sohozkaj.com/tools/image/nid-to-pdf" },
        { labelKey: "tools.image.removeBackground",  subtitle: "Remove Background",      href: "https://sohozkaj.com/tools/image/remove-background" },
        { labelKey: "tools.image.govtJobPhoto",      subtitle: "Govt Job Photo & Sign Resizer", href: "https://sohozkaj.com/tools/image/govt-job-photo-sign" },
        { labelKey: "tools.image.passportToPdf",     subtitle: "Passport to PDF",        href: "https://sohozkaj.com/tools/image/passport-to-pdf" },
        { labelKey: "tools.image.convert",           subtitle: "Image Convert",          href: "https://sohozkaj.com/tools/image/convert" },
        { labelKey: "tools.image.qr",                subtitle: "QR Code Generator",      href: "https://sohozkaj.com/tools/image/qr-code" },
        { labelKey: "tools.image.resize",            subtitle: "Image Size Reducer",     href: "https://sohozkaj.com/tools/image/resize" },
        { labelKey: "tools.image.crop",              subtitle: "Image Crop",             href: "https://sohozkaj.com/tools/image/crop" },
        { labelKey: "tools.image.toPdf",             subtitle: "Image to PDF",           href: "https://sohozkaj.com/tools/image/to-pdf" },
        { labelKey: "tools.image.watermark",         subtitle: "Image Watermark",        href: "https://sohozkaj.com/tools/image/watermark" },
        { labelKey: "tools.image.flatten",           subtitle: "Image Flatten",          href: "https://sohozkaj.com/tools/image/flatten" },
        { labelKey: "tools.image.barcode",           subtitle: "Barcode Generator",      href: "https://sohozkaj.com/tools/image/barcode" },
        { labelKey: "tools.image.colorPicker",       subtitle: "Color Picker",           href: "https://sohozkaj.com/tools/image/color-picker" },
        { labelKey: "tools.image.signaturePad",      subtitle: "Signature Pad",          href: "https://sohozkaj.com/tools/image/signature-pad" },
        { labelKey: "tools.image.signatureFromText", subtitle: "Signature from Text",    href: "https://sohozkaj.com/tools/image/signature-from-text" },
        { labelKey: "tools.image.logoColorChanger",  subtitle: "Logo Color Changer",     href: "https://sohozkaj.com/tools/image/logo-color-changer" },
        { labelKey: "tools.image.compressGif",       subtitle: "GIF Compress",           href: "https://sohozkaj.com/tools/image/compress-gif" },
        { labelKey: "tools.image.upscale",           subtitle: "Image Upscaler",         href: "https://sohozkaj.com/tools/image/upscale" },
        { labelKey: "tools.image.noticeGenerator",   subtitle: "Notice Generator",       href: "https://sohozkaj.com/tools/image/notice-generator" },
      ],
    },

    {
      labelKey: "tools.text.title",
      headerBg:  "bg-sky-100/80 dark:bg-sky-950/30",
      iconBox:   "bg-sky-100 dark:bg-sky-900/30 text-sky-600 dark:text-sky-400",
      titleCls:  "text-sky-600 dark:text-sky-400",
      countCls:  "text-sky-500 dark:text-sky-500",
      toolIcon:  "bg-sky-100/70 dark:bg-sky-900/20 text-sky-600 dark:text-sky-400",
      moreCls:   "text-sky-600 dark:text-sky-400",
      icon: <IconTextSize size={20} />,
      tools: [
        { labelKey: "tools.text.bijoyUnicode", subtitle: "Bijoy ↔ Unicode",        href: "https://sohozkaj.com/tools/text/bijoy-unicode" },
        { labelKey: "tools.text.banglish",     subtitle: "Banglish Typing",         href: "https://sohozkaj.com/tools/text/banglish-typing" },
        { labelKey: "tools.text.numberWords",  subtitle: "Number to Words",         href: "https://sohozkaj.com/tools/text/number-to-words" },
        { labelKey: "tools.text.imageText",    subtitle: "Image to Text",           href: "https://sohozkaj.com/tools/text/image-to-text" },
        { labelKey: "tools.text.analyzer",     subtitle: "Text Analyzer",           href: "https://sohozkaj.com/tools/text/text-analyzer" },
        { labelKey: "tools.text.dateFormat",   subtitle: "Date Format Converter",   href: "https://sohozkaj.com/tools/text/date-format" },
      ],
    },

    {
      labelKey: "tools.video.title",
      headerBg:  "bg-violet-100/80 dark:bg-violet-950/30",
      iconBox:   "bg-violet-100 dark:bg-violet-900/30 text-violet-600 dark:text-violet-400",
      titleCls:  "text-violet-600 dark:text-violet-400",
      countCls:  "text-violet-500 dark:text-violet-500",
      toolIcon:  "bg-violet-100/70 dark:bg-violet-900/20 text-violet-600 dark:text-violet-400",
      moreCls:   "text-violet-600 dark:text-violet-400",
      icon: <IconVideo size={20} />,
      tools: [
        { labelKey: "tools.video.compress",    subtitle: "Compress Video",    href: "https://sohozkaj.com/tools/video/compress" },
        { labelKey: "tools.video.trim",        subtitle: "Trim/Cut Video",    href: "https://sohozkaj.com/tools/video/trim" },
        { labelKey: "tools.video.merge",       subtitle: "Merge Videos",      href: "https://sohozkaj.com/tools/video/merge" },
        { labelKey: "tools.video.audio",       subtitle: "Video to Audio",    href: "https://sohozkaj.com/tools/video/convert" },
        { labelKey: "tools.video.watermark",   subtitle: "Add Watermark",     href: "https://sohozkaj.com/tools/video/watermark" },
        { labelKey: "tools.video.volume",      subtitle: "Audio Volume Booster/Reducer", href: "https://sohozkaj.com/tools/video/volume" },
        { labelKey: "tools.video.speed",       subtitle: "Change Speed",      href: "https://sohozkaj.com/tools/video/speed" },
        { labelKey: "tools.video.gif",         subtitle: "Video to GIF",      href: "https://sohozkaj.com/tools/video/to-gif" },
        { labelKey: "tools.video.rotate",      subtitle: "Rotate / Flip",     href: "https://sohozkaj.com/tools/video/rotate" },
        { labelKey: "tools.video.removeAudio", subtitle: "Remove Audio",      href: "https://sohozkaj.com/tools/video/remove-audio" },
      ],
    },

    {
      labelKey: "tools.general.title",
      headerBg:  "bg-purple-100/80 dark:bg-purple-950/30",
      iconBox:   "bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400",
      titleCls:  "text-purple-600 dark:text-purple-400",
      countCls:  "text-purple-500 dark:text-purple-500",
      toolIcon:  "bg-purple-100/70 dark:bg-purple-900/20 text-purple-600 dark:text-purple-400",
      moreCls:   "text-purple-600 dark:text-purple-400",
      icon: <IconClipboardList size={20} />,
      tools: [
        { labelKey: "tools.general.familyCard", subtitle: "Family Card Form",      href: "https://sohozkaj.com/tools/general/family-card-form" },
        { labelKey: "tools.general.voterMigration", subtitle: "Voter Migration Form", href: "https://sohozkaj.com/tools/general/voter-migration-form" },
        { labelKey: "tools.general.nidCorrection", subtitle: "NID Correction Form", href: "https://sohozkaj.com/tools/general/nid-information-correction-form" },
        { labelKey: "tools.general.specialInformation", subtitle: "Special Information Form", href: "https://sohozkaj.com/tools/general/special-information-form" },
        { labelKey: "tools.general.voterRegistration", subtitle: "Voter Registration Form", href: "https://sohozkaj.com/tools/general/voter-registration-form" },
        { labelKey: "tools.general.voterInclusion", subtitle: "Voter Inclusion Form", href: "https://sohozkaj.com/tools/general/voter-inclusion-form" },
        { labelKey: "tools.general.embassyBirth", subtitle: "Birth Registration Form (Embassy)", href: "https://sohozkaj.com/tools/general/embassy-birth-registration-form" },
        { labelKey: "tools.general.udyog", subtitle: "UDYOG Application Form", href: "https://sohozkaj.com/tools/general/udyog-application-form" },
        { labelKey: "tools.general.fuelCard",   subtitle: "Fuel Card Form",        href: "https://sohozkaj.com/tools/general/fuel-card-form" },
        { labelKey: "tools.general.cvMaker",    subtitle: "ATS Friendly CV Maker", href: "https://sohozkaj.com/tools/general/ats-cv-maker" },
      ],
    },
];

// User menu items - these will be translated in components that use them
export const userMenuItems = [
    // Document Set removed from the main header nav — still available in the sidebar.
    // { value: 'template-sets', labelKey: 'navigation.documentSets', icon: <ModuleIcon src="/module-icons/document-set.svg" />, path: '/template-sets' },
    {
        value: 'my-documents',
        labelKey: 'navigation.myDocuments',
        icon: <IconFileText size={18} stroke={2.2} className={`shrink-0 ${MY_DOCS_ICON_COLOR}`} />,
        path: '/documents',
        matchPaths: ['/documents'],
    },
    {
        value: 'generate-image-ai',
        labelKey: 'navigation.generateImageAI',
        icon: <ModuleIcon src="/module-icons/ai-tools.svg" />,
        path: '/generate-image',
    },
    {
        value: 'generate-image-manual',
        labelKey: 'navigation.generateImageManual',
        icon: <ModuleIcon src="/module-icons/manual-photo-edit.svg" />,
        path: '/generate-image-manual',
        navClass: 'hidden min-[1500px]:inline-flex',
    },
    {
        // Studio before Bulk (2026-11-03): on a medium screen it takes the slot first — the fit guard adds the lower breakpoint
        // first; when the row is full it drops out and the sidebar shows it instead.
        value: 'studio-editor',
        labelKey: 'navigation.studioEditor',
        icon: <ModuleIcon src="/module-icons/studio-editor.svg" />,
        path: '/studio-editor',
        badge: 'New',
        matchPaths: ['/studio-editor'],
        navClass: 'hidden min-[1290px]:inline-flex',
    },
    {
        value: 'bulk-photo-edit',
        labelKey: 'navigation.bulkPhotoEdit',
        icon: <ModuleIcon src="/module-icons/bulk-photo-editing.svg" />,
        path: '/bulk-photo-edit',
        matchPaths: ['/bulk-photo-edit'],
        navClass: 'hidden min-[1390px]:inline-flex',
    },
    {
        value: 'ai-documents',
        labelKey: 'navigation.aiDocuments',
        icon: <ModuleIcon src="/module-icons/ai-documents.svg" />,
        path: '/ai-documents',
        badge: 'New',
        matchPaths: ['/ai-documents'],
        navClass: 'hidden min-[1600px]:inline-flex',
    },
    {
        value: 'ai-templates',
        labelKey: 'navigation.aiTemplates',
        icon: (
            <span className="inline-flex [animation:aiIconSpin_3s_ease-in-out_infinite]">
                <ModuleIcon src="/module-icons/ai-templates.svg" />
                <style>{`@keyframes aiIconSpin { 0%{transform:rotate(0deg) scale(1)} 20%{transform:rotate(-15deg) scale(1.15)} 40%{transform:rotate(15deg) scale(1.15)} 60%{transform:rotate(-8deg) scale(1.05)} 80%{transform:rotate(8deg) scale(1.05)} 100%{transform:rotate(0deg) scale(1)} }`}</style>
            </span>
        ),
        highlight: true,
        path: '/ai-templates',
        categoryDropdown: 'ai',
        matchPaths: ['/ai-templates', '/worldcup-jersey'],
    },
    {
        value: 'question-papers',
        labelKey: 'navigation.questionPapers',
        icon: <ModuleIcon src="/questions-create.svg" />,
        // Clicking the tab jumps straight to the create editor; the saved-paper
        // list now lives in My Files (/documents?tab=questions).
        path: '/questions-create/create',
        matchPaths: ['/questions-create'],
        dropdown: [
            { path: '/questions-create/create', labelKey: 'navigation.questionsCreateOption' },
            { path: '/questions-create/manual', labelKey: 'navigation.questionsManualOption' },
        ],
        navClass: 'hidden min-[1150px]:inline-flex',
    },
    // ── Wide-screen extras — these live in the sidebar drawer normally and move
    // into the header when there is room. Each navClass breakpoint is MIRRORED
    // by a `min-[X]:hidden` on the same item in the sidebar (PrivateLayout's
    // MobileDrawer), so a menu is always in exactly one of the two places.
    {
        value: 'jobs',
        labelKey: 'navigation.jobsMenu',
        icon: <ModuleIcon src="/module-icons/job.svg" />,
        path: '/jobs',
        matchPaths: ['/jobs'],
        navClass: 'hidden min-[1550px]:inline-flex',
    },
    {
        value: 'print-media',
        labelKey: 'navigation.printMedia',
        icon: <ModuleIcon src="/module-icons/print-media.svg" />,
        path: '/print-media',
        categoryDropdown: 'print',
        matchPaths: ['/print-media'],
        navClass: 'hidden min-[1700px]:inline-flex',
    },
    {
        value: 'sohoztools',
        labelKey: 'navigation.sohozTools',
        icon: <ModuleIcon src="/module-icons/easy-tools.svg" />,
        path: null,
        megamenu: { categories: sohozToolsCategories },
    },
];

// Admin menu items - these will be translated in components that use them
export const adminMenuItems = [
    { value: 'dashboard', labelKey: 'navigation.dashboard', icon: <IconLayoutDashboard size={16} />, path: '/admin' },
    {
        value: 'template-sets',
        labelKey: 'navigation.documentSets',
        icon: <IconTemplate size={16} />,
        path: '/admin/template-sets',
        dropdown: [
            { labelKey: 'navigation.documentSets', path: '/admin/template-sets' },
            { labelKey: 'navigation.tags', path: '/admin/tags' },
            { labelKey: 'navigation.categories', path: '/admin/categories' },
        ],
    },
    {
        value: 'ai-templates',
        labelKey: 'navigation.aiTemplates',
        icon: <IconWand size={16} />,
        path: '/admin/ai-templates',
        dropdown: [
            { labelKey: 'navigation.aiTemplateTemplates', path: '/admin/ai-templates' },
            { labelKey: 'navigation.aiTemplateCategories', path: '/admin/ai-template-categories' },
            { labelKey: 'navigation.aiTemplateNegativeFeedback', path: '/admin/ai-templates/negative-feedback' },
        ],
    },
    { value: 'jobs', labelKey: 'navigation.adminJobs', icon: <IconBriefcase size={16} />, path: '/admin/jobs' },
    {
        value: 'print-templates',
        labelKey: 'navigation.printTemplates',
        icon: <IconPrinter size={16} />,
        path: '/admin/print-templates',
        dropdown: [
            { labelKey: 'navigation.printTemplateTemplates', path: '/admin/print-templates' },
            { labelKey: 'navigation.printTemplateCategories', path: '/admin/print-template-categories' },
            { labelKey: 'navigation.printFeedback', path: '/admin/print-feedback' },
        ],
    },
];
